import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	HostBinding,
	OnDestroy,
	OnInit,
	ViewEncapsulation,
} from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { MatLegacyDialogRef as MatDialogRef } from "@angular/material/legacy-dialog";
import { select, Store } from "@ngrx/store";
import { BettingLimitAction, BettingLimitType, CommonState } from "@obg/ngx.common";
import { AbstractTranslatableSnackBarService, Currency, CurrencySelector, MessageType } from "@obg/ngx.core";
import { OBG_VALIDATORS } from "@obg/ngx.ui.common";
import { ignoreNil } from "@obg/rxjs";
import { merge, Subscription } from "rxjs";
import { take, tap } from "rxjs/operators";

@Component({
	selector: "obg-m-login-betting-limit",
	templateUrl: "./iaui-login-betting-limit.component.html",
	styleUrls: ["./iaui-login-betting-limit.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class IauiLoginBettingLimitComponent implements OnInit, OnDestroy {
	@HostBinding("class.obg-m-login-betting-limit") cssHostClass = true;

	readonly bettingLimitType = {
		wageringLimit: BettingLimitType.WageringLimit,
		betSizeLimit: BettingLimitType.BetSizeLimit,
	};

	currency: Currency | undefined;

	bettingLimitForm = this.formBuilder.group({
		limit: this.formBuilder.control("", [Validators.required, OBG_VALIDATORS.numeric, Validators.maxLength(12)]),
		limitType: this.formBuilder.control(BettingLimitType.WageringLimit, Validators.required),
	});

	private data$$: Subscription | undefined;

	constructor(
		private formBuilder: UntypedFormBuilder,
		private store: Store<CommonState>,
		private currencySelector: CurrencySelector,
		private changeDetectorRef: ChangeDetectorRef,
		private snackBarService: AbstractTranslatableSnackBarService,
		private dialogRef: MatDialogRef<IauiLoginBettingLimitComponent>
	) {}

	ngOnInit() {
		const currency$ = this.store.pipe(
			select(this.currencySelector.getByCurrentCustomer()),
			ignoreNil(),
			tap((currency) => (this.currency = currency))
		);

		this.data$$ = merge(currency$).subscribe(() => this.changeDetectorRef.markForCheck());
	}

	ngOnDestroy() {
		this.data$$?.unsubscribe();
	}

	submitBettingLimit() {
		const limitType = this.bettingLimitForm.value.limitType;
		switch (limitType) {
			case BettingLimitType.WageringLimit:
				this.store.dispatch(
					BettingLimitAction.updateWageringLimit({
						amount: this.bettingLimitForm.value.limit,
					})
				);
				break;
			case BettingLimitType.BetSizeLimit:
				this.store.dispatch(
					BettingLimitAction.updateBetSizeLimit({
						limitValue: this.bettingLimitForm.value.limit,
					})
				);
				break;
		}
		this.showSuccessSnackbarAndCloseDialog();
	}

	private showSuccessSnackbarAndCloseDialog() {
		this.snackBarService
			.openSnackBar$({
				prefixJurisdiction: true,
				message: "betting-limit.update-success",
				action: "general.close",
				duration: 4000,
				type: MessageType.Success,
				id: "betting-limit-update-success",
			})
			.pipe(take(1))
			.subscribe(); // eslint-disable-line rxjs/no-ignored-subscription
		this.dialogRef.close();
	}
}
